import type { TaskTrackerBoardCompletedStatusFilter } from '../store/taskTracker.types'
import { DEFAULT_TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTER } from './taskTrackerBoard.stickerFilters.utils'

export const TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTERS_STORAGE_KEY =
  'task-tracker-crm:board-completed-status-filters'

type StoredBoardCompletedStatusFiltersMap = Record<string, unknown>

const isCompletedStatusFilter = (
  value: unknown,
): value is TaskTrackerBoardCompletedStatusFilter =>
  value === 'all' || value === 'completed' || value === 'not_completed'

const readStoredBoardCompletedStatusFiltersMap =
  (): StoredBoardCompletedStatusFiltersMap => {
    if (typeof window === 'undefined') return {}

    try {
      const raw = window.localStorage.getItem(
        TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTERS_STORAGE_KEY,
      )
      if (!raw) return {}

      const parsed: unknown = JSON.parse(raw)
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return {}
      }

      return parsed as StoredBoardCompletedStatusFiltersMap
    } catch {
      return {}
    }
  }

export const readStoredBoardCompletedStatusFilter = (
  boardId: number,
): TaskTrackerBoardCompletedStatusFilter => {
  const stored = readStoredBoardCompletedStatusFiltersMap()[String(boardId)]
  return isCompletedStatusFilter(stored)
    ? stored
    : DEFAULT_TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTER
}

export const writeStoredBoardCompletedStatusFilter = (
  boardId: number,
  status: TaskTrackerBoardCompletedStatusFilter,
) => {
  if (typeof window === 'undefined') return

  try {
    const stored = readStoredBoardCompletedStatusFiltersMap()

    if (status === DEFAULT_TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTER) {
      delete stored[String(boardId)]
    } else {
      stored[String(boardId)] = status
    }

    if (Object.keys(stored).length === 0) {
      window.localStorage.removeItem(
        TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTERS_STORAGE_KEY,
      )
      return
    }

    window.localStorage.setItem(
      TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTERS_STORAGE_KEY,
      JSON.stringify(stored),
    )
  } catch {
    // ignore quota / privacy mode errors
  }
}
